const filterStores = ({ storesData = [], regionId, storeName }) => {
  let newFilteredStores = [...storesData];

  if (regionId) {
    newFilteredStores = newFilteredStores.filter(
      (store) => store.region_id === Number(regionId)
    );
  }

  if (storeName) {
    newFilteredStores = newFilteredStores.filter((store) =>
      store.name.toLowerCase().includes(storeName.toLowerCase())
    );
  }

  return newFilteredStores;
};

export default filterStores;
